import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    ApiKey,
    ApiUrl,
    TransactionType,
    PanelType,
    FixedDepositAmount
} from "../../util/Constant";

import {
    stringIsNullOrEmpty,
    createMultiPartFormBody,
    numberWithCurrencyFormat,
    numberWithCurrencyFormat2,
    numberWithCommas
}
    from "../../util/Util";
import ApiEngine from "../../util/ApiEngine";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setBusy, setIdle, showResponseMessage } from "../../redux/AppAction";
import { Alert } from "reactstrap";
import Spinner from 'react-bootstrap/Spinner';
import classnames from "classnames";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import SweetAlert from "react-bootstrap-sweetalert";

//myr deposit image
import VaderPayIcon from "../../assets/img/assets/VaderPay.svg";
import VaderPayQRIcon from "../../assets/img/assets/VaderPayQR.svg";
import SPGIcon from "../../assets/img/assets/SPG.svg";
import SPGQRIcon from "../../assets/img/assets/SPGQR.svg";
/*import FattyPayIcon from "../../assets/img/assets/FattyPay.svg";*/
import FattyPayIcon from "../../assets/img/assets/FPX_ch3.svg";
import FattyPayQRIcon from "../../assets/img/assets/TruePay.svg";
import PowerPayIcon from "../../assets/img/icon/PowerPay.png";
import DuitNowIcon from "../../assets/img/assets/DuitNowQR.svg";
import PayTrustIcon from "../../assets/img/assets/PayTrust.svg";

import BigPayIcon from "../../assets/img/assets/BigPay.svg";
import BoostPayIcon from "../../assets/img/assets/Boost.svg";
import GrabPayIcon from "../../assets/img/assets/GrabPay.svg";
import MAEIcon from "../../assets/img/assets/MAE.svg";
import DirePayIcon from "../../assets/img/assets/direPay.svg";
import ShopeePayIcon from "../../assets/img/assets/shopeePay.svg";
import TngIcon from "../../assets/img/assets/tng_logo.png";

import EeziePayIcon from "../../assets/img/assets/FPX_ch2.svg";
import EeziePayQRIcon from "../../assets/img/assets/EeziePay.svg";
import SKLIcon from "../../assets/img/assets/SKL99.svg";
import AKPayIcon from "../../assets/img/assets/AKPay_logo.svg";
import PayVemoIcon from "../../assets/img/assets/FPX_ch1.svg";


// Bank icon imports
import AffinIcon from "../../assets/img/v3/full-bank-icon/Affin.svg";
import AllianceBankIcon from "../../assets/img/v3/full-bank-icon/Alliance Bank.svg";
import AlrajhiBankIcon from "../../assets/img/v3/full-bank-icon/Alrajhi Bank.svg";
import AmbankIcon from "../../assets/img/v3/full-bank-icon/Ambank.svg";
import ArgoIcon from "../../assets/img/v3/full-bank-icon/ArgoBank.svg";
import BANKISLAMIcon from "../../assets/img/v3/full-bank-icon/Bank Islam.svg";
import BankMuamalatIcon from "../../assets/img/v3/full-bank-icon/Bank Muamalat.svg";
import BRAKYATIcon from "../../assets/img/v3/full-bank-icon/Bank Rakyat.svg";
import BSNIcon from "../../assets/img/v3/full-bank-icon/BSN.svg";
import CIMBIcon from "../../assets/img/v3/full-bank-icon/CIMB.svg";
import CITIIcon from "../../assets/img/v3/full-bank-icon/CitiBank.svg";
import COPIcon from "../../assets/img/v3/full-bank-icon/COP.svg";
import GXBANKIcon from "../../assets/img/v3/full-bank-icon/GXBank.svg";
import HLBIcon from "../../assets/img/v3/full-bank-icon/HLB.svg";
import HSBCIcon from "../../assets/img/v3/full-bank-icon/HSBC.svg";
import MBBIcon from "../../assets/img/v3/full-bank-icon/Maybank.svg";
import MBSBIcon from "../../assets/img/v3/full-bank-icon/MBSB.svg";
import OCBCIcon from "../../assets/img/v3/full-bank-icon/OCBC.svg";
import PBEIcon from "../../assets/img/v3/full-bank-icon/pbe.svg";
import RHBIcon from "../../assets/img/v3/full-bank-icon/RHB.svg";
import StandardIcon from "../../assets/img/v3/full-bank-icon/Standard.svg";
import UOBIcon from "../../assets/img/v3/full-bank-icon/UOB.svg";

// E-wallet imports
import BoostIcon from "../../assets/img/v3/ewallet-icon/Boost.svg";
import BRAKYATIcon2 from "../../assets/img/v3/ewallet-icon/BRAKYAT.svg";
import DUITNOWIcon from "../../assets/img/v3/ewallet-icon/DUITNOW.svg";
import GPAYIcon from "../../assets/img/v3/ewallet-icon/GPAY.svg";
import GrabpayIcon from "../../assets/img/v3/ewallet-icon/Grabpay.svg";
import ShopeePIcon from "../../assets/img/v3/ewallet-icon/ShopeeP.svg";
import ShopeePay from "../../assets/img/v3/ewallet-icon/ShopeePay.svg";
import TNGoFullWhiteIcon from "../../assets/img/v3/ewallet-icon/TNGo_FullWhite.svg";
import TNGoWHiteIcon from "../../assets/img/v3/ewallet-icon/TNGo_WHite.svg";
import TNGo1Icon from "../../assets/img/v3/ewallet-icon/TNGo-1.svg";

//other image
import TickIcon from "../../assets/img/assets/tick.svg";
import TickIcon1 from "../../assets/img/assets/tick_1.svg";

const InstantDeposit = (props) => {
    const { t } = useTranslation();
    let _dispatch = useDispatch();
    const {
        handleSubmit,
        errors,
        clearErrors,
        setError,
    } = useForm();
    const [showCopyAlert, setShowCopyAlert] = useState(false);
    const [scrollPosition, setScrollPosition] = useState(0);
    const _userData = useSelector(state => state.authState.userData);
    const [bankIsSelected, setBankIsSelected] = useState(false);
    const [providerIsSelected, setProviderIsSelected] = useState(false);
    const [selectedBank, setSelectedBank] = useState({});
    const [selectedBankCode, setSelectedBankCode] = useState("");
    const fixedAmount = FixedDepositAmount;
    const [instantPaymentList, setInstantPaymentList] = useState([]);
    const [loadingPaymentData, setLoadingPaymentData] = useState(true);
    const [paymentOptionList, setPaymentOptionList] = useState([]);
    const [selectedProviderName, setSelectedProviderName] = useState("");
    const [amountValue, setAmountValue] = useState("");
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(0);
    const [serviceCharge, setServiceCharge] = useState(0);
    const [vaderBankList, setVaderBankList] = useState([]);
    const [confirmEeziepaySubmit, setConfirmEeziepaySubmit] = useState(false);
    const [formEvent, setFormEvent] = useState(null);

    const banksList = [
        {
            label: "CIMB",
            img: CIMBIcon
        },
        {
            label: "MAYBANK",
            img: MBBIcon
        },
        {
            label: "PUBLIC BANK",
            img: PBEIcon
        },
        {
            label: "HONG LEONG BANK",
            img: HLBIcon
        },
        {
            label: "RHB",
            img: RHBIcon
        },
        {
            label: "AMBANK",
            img: AmbankIcon
        },
        {
            label: "AFFIN BANK",
            img: AffinIcon
        },
        {
            label: "ALLIANCE BANK",
            img: AllianceBankIcon
        },
        {
            label: "BANK ISLAM",
            img: BANKISLAMIcon
        },
        {
            label: "BANK RAKYAT",
            img: BRAKYATIcon
        },
        {
            label: "BANK SIMPANAN NASIONAL ",
            img: BSNIcon
        },
        {
            label: "CITIBANK",
            img: CITIIcon
        },
        {
            label: "HSBC",
            img: HSBCIcon
        },
        {
            label: "OCBC",
            img: OCBCIcon
        },
        {
            label: "STANDARD CHARTERED BANK",
            img: StandardIcon
        },
        {
            label: "UOB",
            img: UOBIcon
        },
        {
            label: "AGRO BANK",
            img: ArgoIcon
        },
        {
            label: "GX BANK",
            img: GXBANKIcon
        }
    ];

    const ewalletList = [
        {
            label: "BOOST",
            img: BoostIcon
        },
        {
            label: "BANK RAKYAT",
            img: BRAKYATIcon2
        },
        {
            label: "DUITNOW",
            img: DUITNOWIcon
        },
        {
            label: "GPAY",
            img: GPAYIcon
        },
        {
            label: "GRABPAY",
            img: GrabpayIcon
        },
        {
            label: "SHOPEEPAY",
            img: ShopeePayIcon
        },
        {
            label: "SHOPEEP",
            img: ShopeePIcon
        },
        {
            label: "TNG",
            img: TNGo1Icon
        },
        {
            label: "TNGWHITE",
            img: TNGoWHiteIcon
        },
        {
            label: "TNGO",
            img: TNGoFullWhiteIcon
        }
    ];


    //useEffect 
    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (props.memberTransactionHistory.length > 0 && paymentOptionList.length > 0) {
            initMemberTransactionHistoryData();
        }
    }, [paymentOptionList, props.memberTransactionHistory]);

    //init/call function
    async function init() {
        getPaymentList();
    }


    const getPaymentList = async () => {
        let memberJson = await ApiEngine.get(ApiUrl._API_GET_MEMBER_DETAILS_BY_ID);
        var responseGetVaderBankJson = await ApiEngine.get(ApiUrl._API_GET_VADERPAY_BANK_OPTION);
        let responseJsonBank = await ApiEngine.get(
            ApiUrl._API_GET_BANK_LIST
        );

        let bankList = [];
        let providerOptions = [];
        let tempVaderBankList = [];

        if (responseJsonBank[ApiKey._API_SUCCESS_KEY]) {
            responseJsonBank[ApiKey._API_DATA_KEY].forEach(function (bank) {
                bankList.push({
                    name: bank.bankName,
                    id: bank.id,
                });
            });
        }

        if (responseGetVaderBankJson[ApiKey._API_SUCCESS_KEY]) {
            responseGetVaderBankJson[ApiKey._API_DATA_KEY].map((bank) => {
                if (bank.value !== "VaderPay QR") {
                    tempVaderBankList.push({
                        bankCode: bank.bankCode,
                        bankId: bankList.filter(x => x.name === bank.bankName)[0].id,
                        bankInstantRank: bank.bankInstantRank,
                        bankLogo: bank.bankLogo,
                        bankLogo2: bank.bankLogo,
                        currency: "MYR",
                        id: bank.id,
                        maximumDeposit: bank.maximumDeposit,
                        minimumDeposit: bank.minimumDeposit,
                        status: true,
                        name: bank.bankName
                    });
                }
            });
            setVaderBankList(tempVaderBankList);
        }

        let responseJson = await ApiEngine.get(
            ApiUrl._API_GET_USER_PAYMENT_GATEWAY_INFO + "?all=true"
        );

        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            let data1 = [];

            if (memberJson[ApiKey._API_DATA_KEY]["vipId"] === 2)
                data1 = responseJson[ApiKey._API_DATA_KEY];
            else
                data1 = responseJson[ApiKey._API_DATA_KEY].filter((x) => !x.isVIPOnly);

            setInstantPaymentList(responseJson[ApiKey._API_DATA_KEY]);

            data1.filter(y => y.isUmStatus === false).map((option, index) => {
                if (option.instantPayGatewayString == "VaderPay") {
                    option.instantBankSettingModel = tempVaderBankList;
                }

                option.instantBankSettingModel.map((option2, index2) => {
                    let foundIndex = providerOptions.findIndex(x => x.bankId === option2.bankId && x.paymentType === option.paymentType);
                    if (foundIndex === -1) {
                        let temProvider = [];
                        temProvider.push({
                            name: option.instantPayGatewayString,
                            min: option2.minimumDeposit,
                            image: option.instantPayGatewayString === "SPG" ? SPGIcon
                                : option.instantPayGatewayString === "SPG QR" ? SPGQRIcon
                                    : option.instantPayGatewayString === "VaderPay" ? VaderPayIcon
                                        : option.instantPayGatewayString === "VaderPay QR" ? VaderPayQRIcon
                                            : option.instantPayGatewayString === "FattyPay" ? FattyPayIcon
                                                : option.instantPayGatewayString === "TruePay" ? FattyPayQRIcon
                                                    : option.instantPayGatewayString === "PowerPay88" ? PowerPayIcon
                                                        : option.instantPayGatewayString === "PayTrust" ? PayTrustIcon
                                                            : option.instantPayGatewayString === "DirePay" ? DirePayIcon
                                                                : option.instantPayGatewayString === "DirePay QR" ? DirePayIcon
                                                                    : option.instantPayGatewayString === "Eeziepay" ? EeziePayIcon
                                                                        : option.instantPayGatewayString === "Eeziepay QR" ? EeziePayQRIcon
                                                                            : option.instantPayGatewayString === "WinPay" ? FattyPayIcon
                                                                                : option.instantPayGatewayString === "WinPay QR" ? FattyPayIcon
                                                                                    : option.instantPayGatewayString === "SKL" ? SKLIcon
                                                                                        : option.instantPayGatewayString === "SKL QR" ? SKLIcon
                                                                                            : option.instantPayGatewayString === "AKPay" ? AKPayIcon
                                                                                                : option.instantPayGatewayString === "AKPay QR" ? AKPayIcon
                                                                                                    : option.instantPayGatewayString === "PayVemo" ? PayVemoIcon
                                                                                                        : option.instantPayGatewayString === "PayVemo QR" ? PayVemoIcon
                                                                                                            : null,
                        });
                        providerOptions.push({
                            bankId: option2.bankId,
                            name: option2.name,
                            status: option2.status,
                            image: option2.bankLogo2,
                            paymentType: option.paymentType,
                            availableProvider: temProvider,
                            bankInstantRank: option2.bankInstantRank,
                            min: option2.minimumDeposit
                        });
                    } else {
                        if (providerOptions[foundIndex].min > option2.minimumDeposit) providerOptions[foundIndex].min = option2.minimumDeposit;
                        providerOptions[foundIndex].availableProvider.push({
                            name: option.instantPayGatewayString,
                            min: option2.minimumDeposit,
                            image: option.instantPayGatewayString === "SPG" ? SPGIcon
                                : option.instantPayGatewayString === "SPG QR" ? SPGQRIcon
                                    : option.instantPayGatewayString === "VaderPay" ? VaderPayIcon
                                        : option.instantPayGatewayString === "VaderPay QR" ? VaderPayQRIcon
                                            : option.instantPayGatewayString === "FattyPay" ? FattyPayIcon
                                                : option.instantPayGatewayString === "TruePay" ? FattyPayQRIcon
                                                    : option.instantPayGatewayString === "PowerPay88" ? PowerPayIcon
                                                        : option.instantPayGatewayString === "PayTrust" ? PayTrustIcon
                                                            : option.instantPayGatewayString === "DirePay" ? DirePayIcon
                                                                : option.instantPayGatewayString === "DirePay QR" ? DirePayIcon
                                                                    : option.instantPayGatewayString === "Eeziepay" ? EeziePayIcon
                                                                        : option.instantPayGatewayString === "Eeziepay QR" ? EeziePayQRIcon
                                                                            : option.instantPayGatewayString === "WinPay" ? FattyPayIcon
                                                                                : option.instantPayGatewayString === "WinPay QR" ? FattyPayIcon
                                                                                    : option.instantPayGatewayString === "SKL" ? SKLIcon
                                                                                        : option.instantPayGatewayString === "SKL QR" ? SKLIcon
                                                                                            : option.instantPayGatewayString === "AKPay" ? AKPayIcon
                                                                                                : option.instantPayGatewayString === "AKPay QR" ? AKPayIcon
                                                                                                    : option.instantPayGatewayString === "PayVemo" ? PayVemoIcon
                                                                                                        : option.instantPayGatewayString === "PayVemo QR" ? PayVemoIcon
                                                                                                            : null,
                        });
                    }
                })
            });
            setPaymentOptionList(providerOptions.sort((a, b) => a.bankInstantRank - b.bankInstantRank));
        }
        setLoadingPaymentData(false);
    }

    const initMemberTransactionHistoryData = async () => {
        let found = props.memberTransactionHistory.filter(x => x.isInstant && x.transactionTypeId === TransactionType._DEPOSIT);
        if (found.length > 0) {
            if (paymentOptionList.filter(x => x.bankId === found[0].instantBankId).length > 0) {
                setBankIsSelected(true);
                setSelectedBank(paymentOptionList.filter(x => x.bankId === found[0].instantBankId)[0]);
                handleProviderSelection(found[0].instantProviderName, paymentOptionList.filter(x => x.bankId === found[0].instantBankId)[0]);
            }
        }
    }

    function handleProviderSelection(providerName, bank) {
        let index = instantPaymentList.findIndex((x) => x.instantPayGatewayString === providerName);
        if (index !== -1) {
            if (instantPaymentList[index]["instantBankSettingModel"].filter(x => x.bankId === bank.bankId).length > 0) {
                setMin(instantPaymentList[index]["instantBankSettingModel"].filter(x => x.bankId === bank.bankId)[0].minimumDeposit);
                setMax(instantPaymentList[index]["instantBankSettingModel"].filter(x => x.bankId === bank.bankId)[0].maximumDeposit);
                setServiceCharge(instantPaymentList[index]["serviceCharge"]);
                setSelectedProviderName(providerName);
            }
        }
    }

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };

    const handleBankSelection = async (bank) => {
        setBankIsSelected(true);
        setSelectedBank(bank);
        if (paymentOptionList.filter(x => x === bank && x.status === true)[0].availableProvider.length > 0) {
            handleProviderSelection(paymentOptionList.filter(x => x === bank && x.status === true)[0].availableProvider[0].name, bank);
        }
    }


    function resetFormField() {
        setSelectedProviderName("");
        setBankIsSelected(false);
        setSelectedBank({});
        setSelectedBankCode("");
        setMin(0);
        setMax(0);
        setServiceCharge(0);
        setAmountValue("");
    }

    const checkAmountForErrors = async (tempAmountValue) => {
        clearErrors();
        if (parseFloat(tempAmountValue) < min) {
            setError("amount", {
                message: "VALUE_LESS_THAN_MINIMUM",
            });
        }
        else if (parseFloat(tempAmountValue) > max) {
            setError("amount", {
                message: "EXCEED_MAXIMUM_VALUE",
            });
        }
    }

    const checkValueOnSelectFixedAmt = async (fixedAmt) => {
        let updatedValue = (parseFloat(fixedAmt) + parseFloat(stringIsNullOrEmpty(amountValue) ? 0 : amountValue)).toString();
        setAmountValue(
            updatedValue
        );
        clearErrors();
        let tempAmountValue = updatedValue;
        if (parseFloat(tempAmountValue) < min) {
            setError("amount", {
                message: "VALUE_LESS_THAN_MINIMUM",
            });
        }
        else if (parseFloat(tempAmountValue) > max) {
            setError("amount", {
                message: "EXCEED_MAXIMUM_VALUE",
            });
        }
    }


    async function onSubmit(data, e) {
        _dispatch(setBusy());
        let index = instantPaymentList.findIndex((x) => x.instantPayGatewayString === selectedProviderName);
        if (index !== -1) {
            let foundProvider = instantPaymentList[index];
            var bankData = foundProvider["instantBankSettingModel"].filter(
                (option) => option.bankId === selectedBank.bankId
            )[0];

            let params = {
                transactionTypeId: TransactionType._DEPOSIT,
                bankId: bankData.bankId,
                amount: parseFloat(amountValue),
                bankCode: bankData.bankCode,
                channel: foundProvider["instantPayGatewayId"],
                panel: PanelType._MEMBERSITE,
                instantPayBankSettingId: bankData.id,
                currency: bankData.currency,
                instantPay: true,
                receiptReference: selectedProviderName + "(" + foundProvider["instantPayGatewayString"] + ")",
                bankAccountId: bankData.bankId,
            };

            if (!stringIsNullOrEmpty(props.bonusDeposit) && props.bonusDeposit != "-1") {
                params["bonusId"] = props.bonusDeposit;
            } else if (props.bonusDeposit == "-1") {
                params["bonusId"] = "";
            }

            let responseJson = await ApiEngine.post(
                ApiUrl._API_CREATE_TRANSACTION,
                createMultiPartFormBody(params)
            );

            if (responseJson[ApiKey._API_SUCCESS_KEY]) {
                _dispatch(setBusy(true, t("PLEASE_WAIT_REDIRECTING")));

                e.target.reset();
                props.parentInit();

                if (selectedProviderName === "SPG" || selectedProviderName === "VaderPay" || selectedProviderName === "VaderPay QR") {
                    if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                            JSON.stringify({
                                action: "payment",
                                url: responseJson[ApiKey._API_DATA_KEY]["redirect_to"],
                            })
                        );
                    } else {
                        window.location.href =
                            responseJson[ApiKey._API_DATA_KEY]["redirect_to"];

                        setTimeout(() => {
                            _dispatch(setIdle());
                        }, 5000);
                    }
                }
                else if (selectedProviderName === "DirePay QR" || selectedProviderName === "DirePay") {
                    if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                            JSON.stringify({
                                action: "payment",
                                url: responseJson[ApiKey._API_DATA_KEY]["pay_url"],
                            })
                        );
                    } else {
                        window.location.href =
                            responseJson[ApiKey._API_DATA_KEY]["pay_url"];
                        setTimeout(() => {
                            _dispatch(setIdle());
                        }, 5000);
                    }
                }
                else if (selectedProviderName === "Eeziepay QR" || selectedProviderName === "Eeziepay") {
                    try {
                        const blob = new Blob([responseJson[ApiKey._API_DATA_KEY].content], { type: 'text/html' });
                        const url = URL.createObjectURL(blob);
                        const newWindow = window.open(url, '_blank');

                        // Check if the new window was blocked
                        if (!newWindow) {
                            window.alert('Popup blocked. Please allow popups for this site.');
                            return;
                        }

                        setTimeout(() => {
                            URL.revokeObjectURL(url);
                        }, 10000);

                        _dispatch(setIdle());
                    } catch (error) {
                        window.alert('Error creating or opening Blob URL:', error);
                    }
                    _dispatch(setIdle());
                }
                else if (selectedProviderName === "WinPay" || selectedProviderName === "WinPay QR") {
                    if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                            JSON.stringify({
                                action: "payment",
                                url: responseJson[ApiKey._API_DATA_KEY]["url"],
                            })
                        );
                    } else {
                        window.location.href =
                            responseJson[ApiKey._API_DATA_KEY]["url"];

                        setTimeout(() => {
                            _dispatch(setIdle());
                        }, 5000);
                    }
                }
                else if (selectedProviderName === "SKL" || selectedProviderName === "SKL QR") {
                    if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                            JSON.stringify({
                                action: "payment",
                                url: responseJson[ApiKey._API_DATA_KEY]["transaction_link"],
                            })
                        );
                    } else {
                        window.location.href =
                            responseJson[ApiKey._API_DATA_KEY]["transaction_link"];

                        setTimeout(() => {
                            _dispatch(setIdle());
                        }, 5000);
                    }
                }
                else if (selectedProviderName === "AKPay" || selectedProviderName === "AKPay QR") {
                    if (window.ReactNativeWebView) {
                        window.ReactNativeWebView.postMessage(
                            JSON.stringify({
                                action: "payment",
                                url: responseJson[ApiKey._API_DATA_KEY]["data"]["url"],
                            })
                        );
                    } else {
                        window.location.href =
                            responseJson[ApiKey._API_DATA_KEY]["data"]["url"];

                        setTimeout(() => {
                            _dispatch(setIdle());
                        }, 6000);
                    }
                }
                else if (selectedProviderName === "PayVemo" || selectedProviderName === "PayVemo QR") {
                    try {
                        const blob = new Blob([responseJson[ApiKey._API_DATA_KEY].content], { type: 'text/html' });
                        const url = URL.createObjectURL(blob);
                        const newWindow = window.open(url, '_blank');

                        // Check if the new window was blocked 
                        if (!newWindow) {
                            window.alert('Popup blocked. Please allow popups for this site.');
                            return;
                        }

                        setTimeout(() => {
                            URL.revokeObjectURL(url);
                        }, 10000);

                    } catch (error) {
                        window.alert('Error creating or opening Blob URL:', error);
                    }
                    finally { 
                        _dispatch(setIdle());
                    }
                }
                else {
                    window.location.href = responseJson[ApiKey._API_DATA_KEY];
                    _dispatch(setIdle());
                }

            } else {
                _dispatch(
                    showResponseMessage(
                        responseJson[ApiKey._API_SUCCESS_KEY],
                        responseJson[ApiKey._API_MESSAGE_KEY]
                    )
                );
            }
        }
        _dispatch(setIdle());
    }

    return (
        <>
            <SweetAlert
                show={confirmEeziepaySubmit}
                info
                showCancel
                title={t("DISABLE_POPUP")}
                cancelBtnText={t("CANCEL")}
                confirmBtnText={t("CONFIRM")}
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                    handleSubmit((data) => onSubmit(data, formEvent))();
                    setConfirmEeziepaySubmit(false);
                }}
                onCancel={() => {
                    setConfirmEeziepaySubmit(false);
                }}
            />

            {showCopyAlert && (
                <div style={{ position: scrollPosition < 224 ? "relative" : "sticky", top: scrollPosition < 150 ? "107px" : scrollPosition >= 150 && scrollPosition < 160 ? "-65px" : scrollPosition >= 160 && scrollPosition < 170 ? "-55px" : scrollPosition >= 170 && scrollPosition < 180 ? "-45px" : scrollPosition >= 180 && scrollPosition < 190 ? "-35px" : scrollPosition >= 190 && scrollPosition < 200 ? "-25px" : scrollPosition >= 200 && scrollPosition < 210 ? "-15px" : scrollPosition >= 210 && scrollPosition < 224 ? "-5px" : "160px", left: "-55px", width: "100%", color: "white", zIndex: "99999" }}>
                    <div
                        className="content content-full-width"
                        style={{
                            position: "absolute",
                            width: "200px",
                            top: "10px",
                            right: "-40px"
                        }}
                    >
                        <Alert color="green" style={{ textAlign: "center" }}>
                            {t("COPY_SUCCESS")}
                        </Alert>
                    </div>
                </div>
            )}
            <div className="normal-deposit-wrapper">
                {!loadingPaymentData ? <form onSubmit={(e) => {
                    e.preventDefault(); // Prevent the default form submission
                    setFormEvent(e); // Store the event in state
                    if (selectedProviderName === "Eeziepay QR" || selectedProviderName === "Eeziepay") {
                        setConfirmEeziepaySubmit(true); // Show SweetAlert for confirmation
                    } else {
                        handleSubmit((data) => onSubmit(data, e))();
                    }
                }}>
                    {bankIsSelected === false && (
                        <>
                            <div className="all-normal-banks-container">
                                {paymentOptionList.filter(x => x.paymentType === "Instant Payment" && x.status === true).length > 0 && (
                                    <>
                                        <div className="normal-bank-item-container">
                                            <div className="font14 normal-parent-bank-title">
                                                {t("BANK_INSTANT")}
                                            </div>
                                            <div className="deposit-normal-bank-list-container">
                                                {paymentOptionList &&
                                                    paymentOptionList.filter(x => x.paymentType === "Instant Payment" && x.status === true).length > 0 &&
                                                    paymentOptionList.filter(x => x.paymentType === "Instant Payment" && x.status === true).map((child, index) => {
                                                        // Find the matching bank based on name
                                                        const matchedBank = banksList.find(bank => bank.label === child.name);

                                                        return (
                                                            <div
                                                                key={"instant-deposit-bank" + index}
                                                                className="deposit-normal-bank-list-items"
                                                                onClick={() => { handleBankSelection(child) }}
                                                            >
                                                                <div className="bank-min">{t("MIN")} {numberWithCommas(child.min)}</div>
                                                                <img
                                                                    src={matchedBank ? matchedBank.img : child.image}
                                                                    alt="i8 banks"
                                                                    className="img-responsive"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                    )}
                                            </div>
                                        </div>
                                        <hr className="custom-hr" />
                                    </>
                                )}
                                {paymentOptionList.filter(x => x.paymentType === "DuitNow" && x.status === true).length > 0 && (
                                    <>
                                        <div className="normal-bank-item-container">
                                            <div className="font14 normal-parent-bank-title">
                                                {t("EWALLET") + " / " + t("QR_PAY")}
                                            </div>
                                            <div className="deposit-normal-bank-list-container">
                                                {paymentOptionList &&
                                                    paymentOptionList.filter(x => x.paymentType === "DuitNow" && x.status === true).length > 0 &&
                                                    paymentOptionList.filter(x => x.paymentType === "DuitNow" && x.status === true).map((child, index) => {
                                                        // First try to find a match in the e-wallet list
                                                        let matchedPayment = ewalletList.find(wallet => wallet.label.toUpperCase() === (child.name || '').toUpperCase());
                                                        console.log(child.name);
                                                        // If not found in e-wallet list, try to find in bank list as fallback
                                                        if (!matchedPayment) {
                                                            matchedPayment = ewalletList.find(wallet => wallet.label === child.name);
                                                        }

                                                        return (
                                                            <div
                                                                key={"qr-deposit-bank" + index}
                                                                className="deposit-normal-bank-list-items"
                                                                onClick={() => { handleBankSelection(child) }}
                                                            >
                                                                <div className="bank-min">{t("MIN")} {numberWithCommas(child.min)}</div>
                                                                <img
                                                                    src={matchedPayment ? matchedPayment.img : child.image}
                                                                    //alt="instant payment banks"
                                                                    alt={ child.name }
                                                                    className="img-responsive"
                                                                    loading="lazy"
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                    )}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </>
                    )}
                    {bankIsSelected && (
                        <>
                            <div className="normal-bank-per-section-box">
                                <div className="first">
                                    {t("SELECTED_BANK_METHOD")}
                                </div>
                                <div className="second ">
                                    <div className="instant-provider-selected-wrapper-orange">
                                        <div className="instant-provider active" onClick={() => { resetFormField(); }}>
                                            <img className="tick-image" src={TickIcon1} alt="selected bank method" loading="lazy" />
                                            <img className="instant-provider-image"
                                                src={
                                                    // Try to find matching bank image first
                                                    banksList.find(bank => bank.label.toUpperCase() === (selectedBank.name || '').toUpperCase())?.img ||
                                                    // Then try to find matching e-wallet image
                                                    ewalletList.find(wallet => wallet.label.toUpperCase() === (selectedBank.name || '').toUpperCase())?.img ||
                                                    // Otherwise use original image
                                                    selectedBank.image
                                                }
                                                alt="selected bank"
                                                loading="lazy" />
                                        </div>
                                        <div className="other-bank-button" onClick={() => { resetFormField(); }}>
                                            <div className="text">{t("OTHER_BANK")}</div>
                                            <img className="" src="../../img/v3/arrow-right.png" alt="arrowRight" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr className="custom-hr" />
                            <div className="normal-bank-per-section-box">
                                <div className="first">
                                    {!stringIsNullOrEmpty(selectedProviderName) ? t("SELECTED_PROVIDER") : t("PLEASE_SELECT_PROVIDER")}
                                </div>
                                <div className="second ">
                                    <div className="instant-provider-selected-wrapper">
                                        {paymentOptionList &&
                                            paymentOptionList.filter(x => x === selectedBank && x.status === true)[0].availableProvider.length > 0 &&
                                            paymentOptionList.filter(x => x === selectedBank && x.status === true)[0].availableProvider.map((child, index) => {
                                                return (
                                                    <div key={"instant-deposit-provider" + index} className={"instant-provider " + classnames({ active: selectedProviderName === child.name, })} onClick={() => { handleProviderSelection(child.name, selectedBank); }}>
                                                        {selectedProviderName === child.name &&
                                                            <img className="tick-image" src={TickIcon} alt={child.name} loading="lazy" />
                                                        }
                                                        <img className="instant-provider-image"
                                                            src={
                                                                // Try to find matching bank image first
                                                                banksList.find(bank => bank.label.toUpperCase() === (child.name || '').toUpperCase())?.img ||
                                                                // Then try to find matching e-wallet image
                                                                ewalletList.find(wallet => wallet.label.toUpperCase() === (child.name || '').toUpperCase())?.img ||
                                                                // Otherwise use original image
                                                                child.image
                                                            }
                                                            alt={child.title}
                                                            loading="lazy" />
                                                        <div className="bank-min">{t("MIN")} {numberWithCommas(child.min)}</div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {bankIsSelected && selectedProviderName && (
                        <>

                            {parseFloat(serviceCharge) > 0 && parseFloat(serviceCharge) !== 0 && (
                                <>
                                    <hr className="custom-hr" />
                                    <div className="normal-bank-per-section-box">
                                        <div className="first">
                                            {t("SERVICE_CHARGE")}
                                        </div>
                                        <div className="second">
                                            <div className="reminder font-15 text-white font-semi">
                                                {t("SERVICE_CHARGE_DISCLAIM") +
                                                    serviceCharge +
                                                    "%" +
                                                    t("SERVICE_CHARGE_DISCLAIM_BACK")}
                                            </div>
                                        </div>
                                    </div>

                                </>
                            )}
                            <hr className="custom-hr" />
                            <div className="normal-bank-per-section-box">
                                <div className="first">
                                    {t("AMOUNT")}
                                </div>
                                <div className="second ">
                                    <div className="form-group m-b-15 px-0">
                                        <div className="deposit-input-group mb-3">
                                            <span className="currency-prefix">MYR</span>
                                            {<input
                                                type="text"
                                                className="form-white-input"
                                                placeholder={t("PLEASE_ENTER_AMOUNT")}
                                                value={numberWithCommas(amountValue)}
                                                onChange={(event) => {
                                                    let tempValue = event.target.value.replace(/[^0-9]/g, '');
                                                    setAmountValue(tempValue);
                                                    checkAmountForErrors(tempValue);
                                                }}
                                                onPaste={(event) => {
                                                    if (!stringIsNullOrEmpty(window.event.clipboardData.getData('text')) && (/^[1-9]{1,}[0-9]{0,}$/).test(window.event.clipboardData.getData('text'))) {
                                                        setAmountValue(parseInt(window.event.clipboardData.getData('text')));
                                                        event.preventDefault();
                                                    } else {
                                                        setAmountValue('');
                                                        event.preventDefault();
                                                    }
                                                }}
                                            />}
                                            <div className="clear-amount">
                                                <Icon
                                                    path={mdiClose}
                                                    size={1}
                                                    color="#FF0808"
                                                    onClick={() => {
                                                        setAmountValue("");
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        {errors.amount && (
                                            <div className="invalid-feedback">{t(errors.amount.message)}</div>
                                        )}
                                        <div className="font-11 color-white">
                                            {parseFloat(amountValue) >= min ?
                                                <>
                                                    <span>{t("MAIN_WALLET_NEW_BALANCE") + " : "}</span>
                                                    <span>{numberWithCurrencyFormat2(parseFloat(_userData.walletBalance), 2, true) + " "}</span>
                                                    <i className="fas fa-arrow-right" />
                                                    <span>{" " + numberWithCurrencyFormat2(parseFloat(_userData.walletBalance) + (amountValue > 0 ? parseFloat(amountValue) : 0), 2, true)}</span>
                                                </>
                                                :
                                                <>
                                                </>
                                            }
                                        </div>
                                        <div className="instant-provider-reminder">
                                            {min >= 0 && max >= 0 && (

                                                <div className="font-12 amount-limit-reminder">
                                                    <span className="reminder mr-2">
                                                        * {t("MIN")} : MYR {numberWithCommas(min)} / {t("MAX")} : MYR {numberWithCommas(max)}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="amount-row">
                                        {fixedAmount.map((amount, index) => {
                                            return (
                                                <button
                                                    key={"amount-row" + index}
                                                    type="button"
                                                    onClick={() => checkValueOnSelectFixedAmt(amount)}
                                                    className="btn custom-button"
                                                >
                                                    + {numberWithCommas(amount)}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="form-group mt-3 col-md-12 px-0">
                                <button type="submit" className="custom-btn-style-1">
                                    {t("SUBMIT")}
                                </button>
                            </div>
                        </>
                    )}
                </form> :
                    <div style={{ textAlign: "center" }}>
                        <Spinner animation="border" role="status" size="sm"></Spinner>
                    </div>
                }
            </div>
        </>
    );
};

export default InstantDeposit;
